iScreenWizard.config(function ($stateProvider, $urlRouterProvider, $mdDateLocaleProvider) {

    $mdDateLocaleProvider.formatDate = function (date) {
        return moment(date).format('DD-MM-YYYY');
    };

    $urlRouterProvider.rule(function ($injector, $location) {
        var userService = $injector.get('userService');
        userService.RestoreState();
        var path = $location.path(), normalized = path.toLowerCase();

        if (!userService.isAuthenticated()
            && path.indexOf('login') === -1
            && path.indexOf('instant-access') === -1) {
            $location.path('/login');
        }

        if (userService.isAuthenticated() && userService.isPasswordExpired()) {
            $location.path('/mijn-iscreen/renew-password')
        }

        if (path.length < 1) {
            $location.path('/home');
        }
    });

    $stateProvider
        .state('instant-access', {
            url: "/instant-access?jwt=:token",
            controller: "InstantAccessController"
        })
        .state('login', {
            url: "/login",
            controller: "LoginController",
            templateUrl: "/login"
        })
        .state('home', {
            url: "/home",
            controller: "HomeController",
            templateUrl: "/home"
        })
        .state('404', {
            url: "/404",
            templateUrl: "/404"
        })

        //Nieuwe testafname
        .state('nieuwe-testafname/kandidaatgegevens', {
            url: "/nieuwe-testafname",
            controller: "KandidaatgegevensController",
            templateUrl: "/nieuwe-testafname/kandidaatgegevens"
        })
        .state('nieuwe-testafname/selecteer-rapport', {
            url: "/selecteer-rapport",
            controller: "RapporttemplateSelectorController",
            templateUrl: "/nieuwe-testafname/selecteer-rapport"
        })
        .state('nieuwe-testafname/selecteer-losse-tests', {
            url: "/selecteer-losse-tests",
            controller: "LosseTestsSelectorController",
            templateUrl: "/nieuwe-testafname/selecteer-losse-tests"
        })
        .state('nieuwe-testafname/uitnodiging', {
            url: "/uitnodiging",
            controller: "UitnodigingController",
            templateUrl: "/nieuwe-testafname/uitnodiging"
        })

        //Kandidaten
        .state('kandidaten', {
            url: "/kandidaten",
            controller: "KandidaatController",
            templateUrl: "/kandidaten"
        })

        //Matching
        .state('matching', {
            url: "/matching",
            controller: "MatchingController",
            templateUrl: "/matching"
        })
        .state('matching/c2p/competentieprofielen', {
            url: "/matching/c2p/competentieprofielen",
            controller: "C2PCompetentieprofielController",
            templateUrl: "/matching/c2p/competentieprofielen"
        })
        .state('matching/c2p/ideaalscores', {
            url: "/matching/c2p/ideaalscores",
            controller: "C2PIdeaalscoresController",
            templateUrl: "/matching/c2p/ideaalscores"
        })
        .state('matching/c2p/resultaten', {
            url: "/matching/c2p/resultaten",
            controller: "C2PResultatenController",
            templateUrl: "/matching/c2p/resultaten"
        })
        .state('matching/p2c/testafnames', {
            url: "/matching/p2c/testafnames",
            controller: "P2CTestafnameController",
            templateUrl: "/matching/p2c/testafnames"
        })
        .state('matching/p2c/ideaalscores', {
            url: "/matching/p2c/ideaalscores",
            controller: "P2CIdeaalscoresController",
            templateUrl: "/matching/p2c/ideaalscores"
        })
        .state('matching/p2c/resultaten', {
            url: "/matching/p2c/resultaten",
            controller: "P2CResultatenController",
            templateUrl: "/matching/p2c/resultaten"
        })

        //Competentieprofiel
        .state('competentieprofielen', {
            url: "/competentieprofielen",
            controller: "CompetentieprofielController",
            templateUrl: "/competentieprofielen"
        })

        //Groepsprofiel
        .state('groepsprofiel/selecteer-groepsprofieloptie', {
            url: "/groepsprofiel/selecteer-groepsprofieloptie",
            controller: "GroepsprofieloptieSelectorController",
            templateUrl: "/groepsprofiel/selecteer-groepsprofieloptie"
        })
        .state('groepsprofiel/selecteer-testafnames', {
            url: "/groepsprofiel/selecteer-testafnames",
            controller: "GroepsprofielTestafnameSelectorController",
            templateUrl: "/groepsprofiel/selecteer-testafnames"
        })

        //360 Feedback
        .state('360-feedback/selecteer-feedback-rapporttype', {
            url: "/360-feedback/selecteer-feedback-rapporttype",
            controller: "FeedbackRapporttypeSelectorController",
            templateUrl: "/360-feedback/selecteer-feedback-rapporttype"
        })
        .state('360-feedback/feedback-overzicht', {
            url: "/360-feedback/feedback-overzicht",
            controller: "FeedbackOverzichtController",
            templateUrl: "/360-feedback/feedback-overzicht"
        })
        .state('360-feedback/maak-feedback-ronde', {
            url: "/360-feedback/maak-feedback-ronde",
            controller: "MaakFeedbackRondeController",
            templateUrl: "/360-feedback/maak-feedback-ronde"
        })
        .state('360-feedback/selecteer-testafname', {
            url: "/360-feedback/selecteer-testafname",
            controller: "TestafnameSelectorController",
            templateUrl: "/360-feedback/selecteer-testafname"
        })
        .state('360-feedback/feedbackgevers', {
            url: "/360-feedback/feedbackgevers",
            controller: "FeedbackgeversController",
            templateUrl: "/360-feedback/feedbackgevers"
        })
        .state('360-feedback/uitnodiging', {
            url: "/360-feedback/uitnodiging",
            controller: "FeedbackUitnodigingController",
            templateUrl: "/360-feedback/uitnodiging"
        })

        //Info
        .state('info', {
            url: "/info",
            controller: "HomeController",
            templateUrl: "/info"
        })
        .state('info/handleidingen', {
            url: "/info/handleidingen",
            controller: "HandleidingController",
            templateUrl: "/info/handleidingen"
        })
        .state('info/faq', {
            url: "/info/faq",
            controller: "FaqController",
            templateUrl: "/info/faq"
        })
        .state('info/trainingen-en-certificering', {
            url: "/info/trainingen-en-certificering",
            controller: "TrainingEnCertificeringController",
            templateUrl: "/info/trainingen-en-certificering"
        })
        .state('info/klantervaringen', {
            url: "/info/klantervaringen",
            controller: "KlantervaringenController",
            templateUrl: "/info/klantervaringen"
        })
        .state('info/e-learning', {
            url: "/info/e-learning",
            controller: "ELearningController",
            templateUrl: "/info/e-learning"
        })
        .state('info/nieuwsbrief', {
            url: "/info/nieuwsbrief",
            controller: "NieuwsbrievenController",
            templateUrl: "/info/nieuwsbrieven"
        })
        .state('info/testinformatie', {
            url: "/info/testinformatie",
            controller: "TestinformatieController",
            templateUrl: "/info/testinformatie"
        })
        .state('info/ontwikkelwijzer', {
            url: "/info/ontwikkelwijzer",
            controller: "OntwikkelwijzerController",
            templateUrl: "/info/ontwikkelwijzer"
        })

        //Mijn iScreen
        .state('mijn-iscreen', {
            url: "/mijn-iscreen",
            controller: "HomeController",
            templateUrl: "/mijn-iscreen"
        })
        .state('mijn-iscreen/profiel', {
            url: "/mijn-iscreen/profiel",
            controller: "ProfielController",
            templateUrl: "/mijn-iscreen/profiel"
        })
        .state('mijn-iscreen/renew-password', {
            url: "/mijn-iscreen/renew-password",
            controller: "RenewPasswordController",
            templateUrl: "/mijn-iscreen/renew-password"
        })
        .state('mijn-iscreen/accountinformatie', {
            url: "/mijn-iscreen/accountinformatie",
            controller: "AccountinformatieController",
            templateUrl: "/mijn-iscreen/accountinformatie"
        })
        .state('mijn-iscreen/inbox', {
            url: "/mijn-iscreen/inbox",
            controller: "InboxController",
            templateUrl: "/mijn-iscreen/inbox"
        })
        .state('mijn-iscreen/emaillog', {
            url: "/mijn-iscreen/emaillog",
            controller: "EmaillogController",
            templateUrl: "/mijn-iscreen/emaillogs"
        })
        .state('mijn-iscreen/mailtemplates', {
            url: "/mijn-iscreen/mailtemplates",
            controller: "MailtemplateController",
            templateUrl: "/mijn-iscreen/mailtemplates"
        })
        .state('mijn-iscreen/certificaten', {
            url: "/mijn-iscreen/certificaten",
            controller: "CertificaatController",
            templateUrl: "/mijn-iscreen/certificaten"
        });

    $urlRouterProvider.otherwise("/404");

});

var emailTempalateEditor;

iScreenWizard.run(function ($rootScope, $mdDialog, Dictionary) {

    $rootScope.showInfo = function (infoTitle, infoMessage) {
        return $mdDialog.show(
            $mdDialog.alert()
                .clickOutsideToClose(true)
                .title(infoTitle)
                .htmlContent(infoMessage)
                .ariaLabel(infoTitle)
                .ok(Dictionary.translate('app.okay', true))
        );
    };

    $rootScope.trixInitializeMailtemplateTags = function (e, editor) {
        emailTempalateEditor = editor;
        tagSelector =
            '<div class="tag-selector">' +
            '<select name="tag-selector" onchange="emailTempalateEditor.insertString(this.value);this.value=-1;">' +
            '<option disabled selected value="-1">--' + Dictionary.translate('app.insert_tag') + '--</option>' +
            '<optgroup label="' + Dictionary.translate('app.candidate', true) + '">' +
            '<option value="{%FirstName%}">' + Dictionary.translate('app.first_name') + '</option>' +
            '<option value="{%LastName%}">' + Dictionary.translate('app.last_name') + '</option>' +
            '<option value="{%EmailAddress%}">' + Dictionary.translate('app.email') + '</option>' +
            '<option value="{%LanguageName%}">' + Dictionary.translate('app.language') + '</option>' +
            '</optgroup>' +
            '<optgroup label="' + Dictionary.translate('app.test_administration', true) + '">' +
            '<option value="{%IdentityCode%}">' + Dictionary.translate('app.test_code') + '</option>' +
            '<option value="{%StartPageTestAssignment%}">' + Dictionary.translate('app.test_start_page') + '</option>' +
            '</optgroup>' +
            '<optgroup label="' + Dictionary.translate('app.organisation', true) + '">' +
            '<option value="{%CompanyName%}">' + Dictionary.translate('app.name') + '</option>' +
            '<option value="{%CompanyLogo%}">' + Dictionary.translate('app.logo') + '</option>' +
            '</optgroup>' +
            '<optgroup label="' + Dictionary.translate('app.user', true) + '">' +
            '<option value="{%UserFirstName%}">' + Dictionary.translate('app.first_name') + '</option>' +
            '<option value="{%UserLastName%}">' + Dictionary.translate('app.last_name') + '</option>' +
            '<option value="{%UserEmailAddress%}">' + Dictionary.translate('app.email') + '</option>' +
            '<option value="{%UserName%}">' + Dictionary.translate('app.name') + '</option>' +
            '</optgroup>' +
            '<optgroup label="' + Dictionary.translate('app.360_feedback', true) + '">' +
            '<option value="{%FirstNameSource%}">' + Dictionary.translate('app.source_candidate_first_name') + '</option>' +
            '<option value="{%LastNameSource%}">' + Dictionary.translate('app.source_candidate_last_name') + '</option>' +
            '</optgroup>' +
            '<optgroup label="' + Dictionary.translate('app.remaining', true) + '">' +
            '<option value="{%ReceiptConfirmation%}">' + Dictionary.translate('app.acknowledgment_of_receipt') + '</option>' +
            '</optgroup>' +
            '</select>' +
            '</div>';
        angular.element(document).find('trix-toolbar').append(tagSelector);
    };

});

iScreenWizard.filter('nl2br', ['$sce', function ($sce) {
    return function (text) {
        return text ? $sce.trustAsHtml(text.replace(/\n/g, '<br/>')) : '';
    };
}]);